import { t } from 'ttag'

import {
  FileTextIcon,
  LifeBuoyIcon,
  GridIcon,
  UsersIcon,
  TargetIcon,
  CloudIcon,
} from 'components/shared/Icon/model'
import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import {
  DEFAULT_CAREER_TEMPLATES_QUERY_PARAMS,
  DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS,
} from 'constants/templates'
import { DEFAULT_DEPARTMENTS_QUERY_PARAMS } from 'constants/departments'
import { DEFAULT_PANEL_QUERY_PARAMS } from 'constants/panel'
import {
  toCareer,
  toModel,
  toPage,
  toProjects,
  toTemplates,
  toDepartments,
  toPanel,
} from 'ducks/router'
import type { FeatureKey, RoleKey } from 'generated/features'

export const ACCOUNT_TYPE = 'ACCOUNT_TYPE'
export const DOCUMENTS_TYPE = 'DOCUMENTS_TYPE'
export const CAREER_TYPE = 'CAREER_TYPE'
export const HOME_TYPE = 'HOME_TYPE'
export const JOBS_TYPE = 'JOBS_TYPE'
export const TEMPLATES_TYPE = 'TEMPLATES_TYPE'
export const DEPARTMENTS_TYPE = 'DEPARTMENTS_TYPE'
export const TRAINING_TYPE = 'TRAINING_TYPE'
export const PANEL_TYPE = 'PANEL_TYPE'

type NavigationLink = {
  icon: unknown
  label: string
  type: string
  isActive?: (match: unknown, location: { pathname: string }) => boolean
  // shown only when the account has the feature, or the user has the role
  isExact?: boolean
  feature?: FeatureKey
  role?: RoleKey
}

export const getNavigationLinks = (): NavigationLink[] => [
  { icon: TargetIcon, label: t`jobs`, type: JOBS_TYPE },
  {
    icon: FileTextIcon,
    label: t`templates`,
    type: TEMPLATES_TYPE,
    isActive: (_, location) => location.pathname.includes('/templates/'),
  },
  // { icon: FileIcon, label: t`documents`, type: DOCUMENTS_TYPE },
  {
    icon: CloudIcon,
    label: t`career`,
    type: CAREER_TYPE,
    feature: 'enable_talent_assessment',
    isActive: (_, location) => location.pathname.includes('/career/'),
  },
  // {
  //   icon: SettingsIcon,
  //   label: t`account`,
  //   role: 'accountAdmin',
  //   type: ACCOUNT_TYPE,
  // },
  // {
  //   icon: SettingsIcon,
  //   label: t`account`,
  //   role: 'accountAdmin',
  //   type: ACCOUNT_TYPE,
  // },
  {
    icon: LifeBuoyIcon,
    label: t`training`,
    feature: 'trainingPage',
    type: TRAINING_TYPE,
  },
  {
    icon: GridIcon,
    label: t`departments`,
    role: 'accountAdmin',
    type: DEPARTMENTS_TYPE,
  },
  {
    icon: UsersIcon,
    label: t`access control`,
    role: 'accountAdmin',
    type: PANEL_TYPE,
  },
]

export const getLinkActions = type => {
  const mapTypeToLinkAction = {
    [JOBS_TYPE]: toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS),
    [TEMPLATES_TYPE]: toTemplates(
      'interviews',
      null,
      DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS,
    ),
    [DEPARTMENTS_TYPE]: toDepartments(null, DEFAULT_DEPARTMENTS_QUERY_PARAMS),
    [DOCUMENTS_TYPE]: toModel('documents', null, null, {
      limit: 25,
      offset: 0,
      ordering: ['title'],
    }),
    [CAREER_TYPE]: toCareer(
      'overview',
      null,
      DEFAULT_CAREER_TEMPLATES_QUERY_PARAMS,
    ),
    [ACCOUNT_TYPE]: toPage('account'),
    [TRAINING_TYPE]: toPage('training'),
    [PANEL_TYPE]: toPanel(null, DEFAULT_PANEL_QUERY_PARAMS),
  }

  return mapTypeToLinkAction[type]
}
